import ContractsDashboard from "../modules/contracts/ContractsDashboard";
import ProposalsDashboard from "../modules/proposals/ProposalsDashboard";
import AdminDashboard from "../modules/admin/AdminDashboard";
import { ROLES } from "../services/users";

export const MODULES = [
  {
    id: "contracts",
    path: "/contracts",
    label: "Contracts",
    component: ContractsDashboard,
    requiredRole: ROLES.USER,
  },
  {
    id: "proposals",
    path: "/proposals",
    label: "Proposals",
    component: ProposalsDashboard,
    requiredRole: ROLES.USER,
  },
  {
    id: "admin",
    path: "/admin",
    label: "Admin",
    component: AdminDashboard,
    requiredRole: ROLES.ADMIN,
  },
];
